<template>
  <div class="col-6 text-end" v-if="visible">
    <div class="popup_bg"></div>
    <div id="myModal" class="modal_class">
      <div class="modal-content invoice">
        <div class="d-flex justify-content-between">
          <span>Duplicate PPPOE ID Detect</span>
          <span @click="$emit('close')" class="close">&times;</span>
        </div>

        <div
          class="hover-popup my-3"
          style="height: 300px; overflow-y: auto; scrollbar-width: thin"
        >
          <div class="table-responsive">
            <table id="users-list" class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    OLT
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    PON NO.
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    DESCRIPTION
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    ONU INFO
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    STATUS
                  </th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="(item, index) in multipleData.data" :key="index">
                  <td>{{ item.olt_connect }}</td>
                  <td>{{ item.port_number }}</td>
                  <td>
                    Pppoe Users
                    <i
                      @click="$emit('delete', item.id)"
                      class="fas fa-trash-alt mx-2 cursor-pointer"
                      style="color: red; font-size: 12px"
                    ></i>
                    <br />
                    <span
                      v-for="(item_str, index) in formatData(item.ppoe_id) ?? []"
                      :key="index"
                      class="mx-3s"
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <router-link
                        v-if="item_str"
                        class="dark-filter"
                        :to="{ name: 'Graph', params: { pppoe: item_str } }"
                        >*{{ item_str }}</router-link
                      >
                      <br
                    /></span>
                  </td>

                  <td>
                    <ul style="list-style: none; padding: 0; margin: 0">
                      <li>Port: {{ item.port_number }}</li>
                      <li>Port Type: {{ item.port_type }}</li>
                      <li>
                        Running Connections: {{ item.running_connection_port }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <p
                      class="badge"
                      :style="{ backgroundColor: item.bgcolor }"
                    >
                      {{ item.status_is }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleListPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    multipleData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatData(data) {
      return data ? data.split(",") : [];
    },
  },
};
</script>

